import { Component, OnInit } from '@angular/core';
import { PopupComponent } from '../../popup.component';

@Component({
    selector: 'ez-popup-picture-auth',
    template: require('./popup-picture-auth.component.html'),
    styles: [require('./popup-picture-auth.component.less')]
})
export class PictureAuthPopupComponent extends PopupComponent implements OnInit {
    private hasAuth: boolean = false;
    private displayName: string = '';

    public ngOnInit() {
        if (this.popupService.hasData('hasAuth')) {
            this.hasAuth = this.popupService.getData('hasAuth');
        }
        if (this.popupService.getData('displayName')) {
            this.displayName = this.popupService.getData('displayName');
        }
    }

    public accept() {
        this.sendResult({
            result: true
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/popup/types/pictureAuth/popup-picture-auth.component.ts